const Prompts = {

    getStatementTextPrompt(statement: string, executionPlan: string, instanceType: string): string {
        return `I have a sql statement for ${instanceType}: ${statement}, With execution plan: ${executionPlan}. How can I tune it?`
    },

    getInstanceWaitsPrompt(waits: string[], instanceType: string | undefined ): string {
        const isMoreThanOne = waits.length > 1
        return `My ${instanceType} database is spending a lot of time in "${waits.join(', ')}". How can I reduce ${isMoreThanOne ? 'these' : 'this'}?`;
    },

    getInstanceWaitPrompt(wait: string, instanceType: string | undefined ): string {
        return `What does the wait event "${wait}" mean in ${instanceType} and how can I reduce it?`;
    },

    getDeadLockPrompt(deadLock: string, instanceType: string | undefined ): string {
        return `My ${instanceType} database had a deadlock: ${deadLock} How can I avoid this happening?`;
    },

};

export default Prompts;
